/**
 * 搜索列表 组件
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 *
 * 开放接口
 * handleFetch => fun(
 *     @页码，默认1;
 *    @flagUseLastSearch是否使用已用搜索条件,此配置不含前置条件不,默认false;
 *    @params 查询参数：选填，flagUseLastSearch为false可设置值，默认空;
 * )  => {}
 *
 * 必传参数
 * renderList           渲染列表
 *
 * 可选传参数：
 * searchFormOptions    搜索表格配置项，配置则显示搜索项
 * topSearchRightCont   搜索 表格右则右定义内容，无配置搜索表格配置项不显示此部分内容
 * precondition         搜索前置条件
 * initFetch            进入是否查询 默认为true
 * paginationFlag       是否显示页码 默认true
 * flagShowReset        是否显示重置
 * showTotal            是否显示总条数
 *
 * precondition     搜索前置条件
 * specialHandle    特别处理(查询前处理)
 *
 * topSearchFarLeft: PropTypes.func, // 搜索表单最左的内容
 *
 * 方法
 * searchReset          重置方法，谨传，传此方法请自行处理重置数据逻辑
 */
import React from 'react';
import {Pagination, Empty,Spin,message,Button} from "antd";
import Lang from "@components/Lang/Lang";
import {isEmpty,trim, toFixed2,formatNumberToPrice,symbolMoneyUtil} from '@utils/utils';
import "./AutoFetchList.less";
import SearchForm from '@components/SearchForm/SearchForm';
import AutoFetchListService from "./AutoFetchList.action";
import PropTypes from "prop-types";
class AutoFetchList extends React.Component{
    static propTypes = {
        renderList: PropTypes.any.isRequired,
        fetchApi: PropTypes.string.isRequired,
        searchFormOptions: PropTypes.array,
        initFetch: PropTypes.bool,
        precondition: PropTypes.object,
        paginationFlag: PropTypes.bool,
        searchReset:PropTypes.func,
        flagShowReset: PropTypes.bool,
        flagShowSearchBtn: PropTypes.bool,
        showTotal: PropTypes.bool,
        topSearchFarLeft: PropTypes.any, // 搜索表单最左的内容
    }
    static defaultProps = {
        fetchApi:'',
        searchFormOptions: [],
        initFetch: true,
        paginationFlag: true,
        flagShowReset: true,
        flagShowSearchBtn: true,
        topSearchLeftCont:null,
        topSearchRightCont:null,
        pageSize:10,
        precondition:{},
        showTotal:true,
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list:[],
            pageSize: props.pageSize,
            pageIndex: 1,
            total: 0,
        }
    }
    /**
     * 搜索
     ***/
    getFormData(values={}) {
        this.fetch(1,values)
    }
    /**
     * 重置
     **/
    searchReset(){
        if(this.props.searchReset){
            this.props.searchReset();
        }else this.fetch(1,{});
    }
    /**
     * 搜索
     ***/
    renderList(list=[]){
        let children = []
        list.forEach((item,index)=>{
            children.push(this.props.renderList(item,index))
        })
        return children;
    }

    /**
     * 外部调用接口
     * @param pageIndex  查询页码
     * @param flagUseLastSearch  是否采用上次的搜索条件
     * @param params  查询参数
     */
    handleFetch = ( pageIndex=1,flagUseLastSearch = false,params={}) => {
        this.fetch(pageIndex, flagUseLastSearch?this.state.lastSearchCondition:params)
    }
    /**
     * 搜索
     * @param pageIndex 页码
     * @param fetchCondition 条件
     */
    fetch(pageIndex=1,fetchCondition={}){
        this.loading(true);
        const { fetchApi,precondition} = this.props;
        const { pageSize,} = this.state;
        // 处理 空值
        let newSearchMap = {...precondition,...fetchCondition};
        for(let key in newSearchMap){
            if(isEmpty(newSearchMap[key])) delete newSearchMap[key];
        }
        if(this.props.specialHandle){
            const newL = this.props.specialHandle(newSearchMap);
            newSearchMap={...newSearchMap,...newL}
        }
        AutoFetchListService.fetch(fetchApi,pageSize, pageIndex,newSearchMap).then((resp)=>this.handleRes(resp.data,pageIndex,fetchCondition)).catch(err=>this.handleErr(err));
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    handleRes(res={},pageIndex=1,fetchCondition={}){
        this.loading(false);
        const {success,valid,models,paging={}} = res;
        if (success && valid) {
            if(this.props.fetchCallBack){
                this.props.fetchCallBack(res);
            }
            const resList = models || [];
            this.setState({
                list: resList,
                total: paging.total||0,
                pageIndex:pageIndex,
                lastSearchCondition:fetchCondition
            })
            $(document).scrollTop(0);
        }else {
            this.resetList();
            if(res.message)message.error(res.message);
        }
    }
    resetList(){
        this.setState({
            list: [],
            total: 0,
            pageIndex:1,
        })
    }
    handleErr(err){
        this.loading(false);
    }
    /**
    * 切换页码
    * **/
    onChangePage(page,currPageSize){
        const { pageSize } = this.state;
        if(currPageSize!=pageSize){
            this.setState({
                pageSize:currPageSize
            },()=>this.fetch(page,this.state.lastSearchCondition))
        }else this.fetch(page,this.state.lastSearchCondition);
    }

    goTop  = ()=> {
        $(document).scrollTop(0);
    }
    onRefSearch = (ref) =>  this.onRefSearchChrld = ref;
    /**
     * 右则
     * */
    getRight(topSearchRightCont,exportSetting={}){
        let children = []
        if(exportSetting.exportUrl&&exportSetting.exportTemplate){
            const btnExport =(<div className={'textRight'}>
                <Button onClick={() =>this.handleExport()}
                        icon={<span className="ri-logout-box-r-line font_14"></span>}>
                    <span className="font_12">{Lang({id: "DaoChuShuJu"})}</span>
                </Button>
            </div>);
            if(topSearchRightCont){
                children.push(topSearchRightCont)
            }
            children.push(btnExport)
        }else if(topSearchRightCont){
            children.push(topSearchRightCont)
        }
        return children;
    }
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
        if(this.props.initFetch) this.fetch(1,this.props.fetchCondition);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { list, loading,pageIndex,pageSize,total,} = this.state;
        const { topSearchRightCont, searchFormOptions,paginationFlag,flagShowReset,flagShowSearchBtn,children,precondition,
            topSearchLeftCont,topSearchLeftRight,topSearchFarLeft,exportSetting} = this.props;
        return ( <Spin spinning={loading}>
            <div className={'autoFetchList'}>
                {searchFormOptions.length>0&&<div className={'top-search'}>
                    <SearchForm
                        onRef={this.onRefSearch}
                        options = {searchFormOptions}
                        searchLeft = {topSearchFarLeft}
                        setRight = {this.getRight(topSearchRightCont,exportSetting)} //  UI混来混去的锅，只能各种配置
                        setLeft = {topSearchLeftCont} //  UI混来混去的锅，只能各种配置
                        setLeftBtnRight = {topSearchLeftRight} //  UI混来混去的锅，只能各种配置
                        initialValues={precondition}
                        searchReset={(dat)=>this.searchReset(dat)}
                        flagShowReset={flagShowReset}
                        flagShowSearchBtn={flagShowSearchBtn}
                        getSearchValue={this.getFormData.bind(this)} />
                </div>}
                {children}
                {list.length >0 ? (<div className="content-wrap">
                        <div className={"fetch-list"}>
                            {this.renderList(list)}
                        </div>
                        {paginationFlag&&<div className="margin-top-20 text-center"> {/*分页*/}
                        <Pagination
                            total={total}
                            // showTotal= {(total) =>showTotal?`Total ${total} items`:''}
                            defaultPageSize={pageSize}
                            current={pageIndex}
                            // showSizeChanger
                            showQuickJumper
                            onChange={this.onChangePage.bind(this)}
                        />
                    </div>}
                </div>):(<div className={"emptyWrap"}>
                    {loading?null:<Empty description={Lang({id: "WeiZhaoDaoFuHeTiaoJianDeJiLu",default: "未找到符合条件的记录"})} />}
                </div>) }

            </div>
        </Spin> )
    }
}
export default AutoFetchList;
